import React, { useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import parse from "autosuggest-highlight/parse";
import throttle from "lodash/throttle";

import { memo } from "react";
import { geocodeByPlaceId } from "react-places-autocomplete";
import Geocode from "react-geocode";
import { useLocation } from "react-router-dom";
import { useState } from "react";
import MuiAlert from "@mui/material/Alert";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import Slide from "@mui/material/Slide";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

Geocode.setApiKey(process.env.REACT_APP_GEO_API_KEY);
Geocode.enableDebug();

var abc = {
  description: "Current Location",
  matched_substrings: [
    {
      length: 1,
      offset: 0,
    },
  ],
  place_id: "0",
  reference: "ChIJDdMfySEFdkgRVkEX9DXbVvU",
  structured_formatting: {
    main_text: "Current Location",
    main_text_matched_substrings: [
      {
        length: 1,
        offset: 0,
      },
    ],
    secondary_text: "Set your location as pickup address",
  },
  terms: [
    {
      offset: 0,
      value: "Current Location",
    },
    {
      offset: 18,
      value: "London",
    },
    {
      offset: 26,
      value: "UK",
    },
  ],
  types: ["premise", "geocode"],
};


const autocompleteService = { current: null };

const useStyles = makeStyles((theme) => ({
  icon: {
    color: theme.palette.text.secondary,
    marginRight: theme.spacing(2),
  },
}));

function MaterialAuto({

  type,
  pickup,
  drop,
  setPickup,
  setPath,
  setDrop,
  setUserInteracting,
  waydrop,
  setWaydrop,
  waydropIndex,
}) {
  const location = useLocation();

 

  // console.log("waydrop",waydrop);

  const params = new URLSearchParams(location.search);

  let pickupCheck = params.get("pickupplace");
  let dropCheck = params.get("dropplace");
  

  const classes = useStyles();

  const [currentAddress, setCurrentAddress] = useState("");

  const [value, setValue] = React.useState(null);
  const [inputValue, setInputValue] = React.useState("");
  const [options, setOptions] = React.useState([""]);

  const [checkCurrentLocation, setCurrentLocation] = useState(true);
  const [currentLatLng, setCurrentLatLng] = useState({
    lat: 0.0,
    lng: 0.0,
  });
  const [driverAddress, setDriverAddress] = useState("");

  // Get Lat Lng start

  
  const fetch = React.useMemo(
    () =>
      throttle((request, callback) => {
        request.componentRestrictions = { country: "ae" };
        // request.componentRestrictions = { country: "in" };

        autocompleteService.current.getPlacePredictions(request, callback);
      }, 200),
    []
  );

  React.useEffect(() => {
    // console.log("check: 3");
    let active = true;

    if (!autocompleteService.current && window.google) {
      autocompleteService.current =
        new window.google.maps.places.AutocompleteService(null, {
          componentRestrictions: { country: "ae" },
          // componentRestrictions: { country: "in" },
        });
    }
    if (!autocompleteService.current) {
      return undefined;
    }

    if (inputValue === "") {
      setOptions(value ? [value] : []);
      return undefined;
    }

    fetch({ input: inputValue }, (results) => {
      if (active) {
        let newOptions = [];

        if (value) {
          newOptions = [value];
        }

        if (results) {
          newOptions = [...newOptions, ...results];
        }

        setOptions(newOptions);
      }
    });

    return () => {
      active = false;
    };
  }, [value, inputValue, fetch]);

  React.useEffect(() => {
    // console.log("useEffect triggered");
    // console.log("value:", value);
    // console.log("inputValue:", inputValue);

    // ... rest of your code
  }, [value, inputValue]);

  const [errorMessage, setErrorMessage] = useState(false);

  function getloc() {
    // console.log("Geocode getloc");
    navigator.geolocation.getCurrentPosition(
      function (position) {
        // console.log("Geocode position", position);
        const newLatLng = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        setCurrentLatLng(newLatLng);
        
        // Use Google Maps Geocoder for reverse geocoding
        const geocoder = new window.google.maps.Geocoder();
        const latLng = new window.google.maps.LatLng(newLatLng.lat, newLatLng.lng);
        
        geocoder.geocode({ location: latLng }, (results, status) => {
          let address = `Current Location (${newLatLng.lat.toFixed(4)}, ${newLatLng.lng.toFixed(4)})`;
          
          if (status === "OK" && results[0]) {
            address = results[0].formatted_address;
          }
          
          setDriverAddress(address);
          let place = {
            address: address,
            coords: latLng,
          };
          setUserInteracting(false);
          setPickup(place);
        });
      },
      function (error) {
        // PositionError codes: 1 = PERMISSION_DENIED, 2 = POSITION_UNAVAILABLE, 3 = TIMEOUT
        console.error("Geolocation error code:", error.code, "message:", error.message);
        if (error.code === 1) {
          // PERMISSION_DENIED
          setErrorMessage(true);
        } else if (error.code === 2) {
          // POSITION_UNAVAILABLE
          console.error("Position unavailable");
        } else if (error.code === 3) {
          // TIMEOUT
          console.error("Geolocation request timeout");
        }
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      }
    );
  }

  const handleClickOpen = () => {
    // alert('enter');
    setErrorMessage(true);
  };

  const handleClose = () => {
    setErrorMessage(false);
    // let place = {
    //   address: '',
    //   coords: coords1
    // };
    // setPickup(place);
  };

  // console.log("waydrop",waydrop);


  // console.log("pickup",pickup);
  


  // useEffect(() => {
  //   console.log("check: 1");
  //   console.log("inputValue 1", inputValue);
  //   console.log("inputValue 2", checkCurrentLocation);
  //   if (inputValue !== "" && inputValue === "Current Location") {
  //     // if (pickup.coords.lat() !== 0) {
  //     if (checkCurrentLocation) {
  //       setOpen(false);
  //     } else {
  //       handleClickOpen();
  //       console.log("Error: ");
  //     }
  //   }
  // }, [inputValue, value, checkCurrentLocation, geolocated]);

  return (
    <>
    
      <Dialog
        open={errorMessage}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"Google's location service Error!"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {errorMessage
              ? "Location Permission Denied, Please enable location access on site settings."
              : "Error retrieving location. Please try again."}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
      <Autocomplete
        id="google-map-demo"
        style={{ width: "100%" }}
        getOptionLabel={(option) =>
          typeof option === "string" ? option : option.description
        }
        filterOptions={(x) => {
          if (type == "pickup") {
            x.push(abc);
          }

          if (type == "pickup") {
            if (value && value.description === "Current Location") {
              setValue("");

              // setPickup()
            }
            if (value == null) {
              setValue("");
            }
          }

          return x;
        }}
        options={options}
        autoComplete
        searchOptions
        includeInputInList
        filterSelectedOptions
        value={
          type === "pickup"
            ? pickup?.address || pickupCheck || currentAddress
            : type === "drop"
            ? drop?.address || dropCheck
            : waydrop?.address || ""
        }
               
        onChange={(event, newValue) => {
          setOptions(newValue ? [newValue, ...options] : options);
          setUserInteracting(true);
          setValue(newValue);
          // if (newValue) {
          //   if (type === "pickup") {
          //     if (newValue.place_id === "0") {
          //       if (currentLatLng.lat !== 0) {
          //         let place = {
          //           address: driverAddress,
          //           coords: new window.google.maps.LatLng(
          //             currentLatLng.lat,
          //             currentLatLng.lng
          //           ),
          //         };
          //         setUserInteracting(false);
          //         setCurrentLocation(true);
          //         setPickup(place);

          //         // console.log("place 1:", place);
          //       } else {
          //         // setCurrentLocation(false);
          //         // setPickup(pickup);
          //         // setUserInteracting(false);
          //         // console.log("place 2:", pickup);
          //         getloc();
          //       }
          //     } else {
          //       geocodeByPlaceId(newValue.place_id)
          //         .then((results) => {
          //           let place = {
          //             // address: results[0].formatted_address,
          //             address: newValue.description,
          //             coords: results[0].geometry.location,
          //           };
          //           setUserInteracting(false);
          //           setPickup(place);
          //           // console.log("place 3:", place);
          //         })
          //         .catch((error) => console.error(error));
          //     }
          //   } else {
          //     geocodeByPlaceId(newValue.place_id)
          //       .then((results) => {
          //         let place = {
          //           // address: results[0].formatted_address,
          //           address: newValue.description,
          //           coords: results[0].geometry.location,
          //         };
          //         setUserInteracting(false);
          //         setDrop(place);
          //         // console.log("place 4:", place);
          //       })
          //       .catch((error) => console.error(error));
          //     // setDrop(newValue)
          //   }
          // } else {
          //   if (newValue === null && type === "drop") {
          //     let drop_coords = new window.google.maps.LatLng(0.0, 0.0);
          //     setDrop({
          //       isOpen: false,
          //       coords: drop_coords,
          //       address: "",
          //     });
          //     setPath([]);
          //   } else {
          //     let coords = new window.google.maps.LatLng(
          //       25.237078489210994,
          //       55.447202757114084
          //     );
          //     setPickup({
          //       isOpen: false,
          //       coords: coords,
          //       address: "",
          //     });
          //   }
          // }

          if (newValue) {
            if (type === "pickup") {
              if (newValue.place_id === "0") {
                // Request current location
                getloc();
              } else {
                geocodeByPlaceId(newValue.place_id)
                  .then((results) => {
                    let place = {
                      address: newValue.description,
                      coords: results[0].geometry.location,
                    };
                    setUserInteracting(false);
                    setPickup(place);
                  })
                  .catch((error) => console.error(error));
              }
            } else if (type === "drop") {
              geocodeByPlaceId(newValue.place_id)
                .then((results) => {
                  let place = {
                    address: newValue.description,
                    coords: results[0].geometry.location,
                  };
                  setUserInteracting(false);
                  setDrop(place);
                })
                .catch((error) => console.error(error));
            } else if (type === "waydrop") {
              geocodeByPlaceId(newValue.place_id)
                .then((results) => {
                  let place = {
                    address: newValue.description,
                    coords: results[0].geometry.location,
                  };
                  setUserInteracting(false);
                  setWaydrop(waydropIndex, place); // update specific index
                })
                .catch((error) => console.error(error));
            }
          } else {
            if (type === "drop") {
              setDrop({ isOpen: false, coords: new window.google.maps.LatLng(0, 0), address: "" });
              setPath([]);
            } else if (type === "pickup") {
              setPickup({ isOpen: false, coords: new window.google.maps.LatLng(25.237078489210994, 55.447202757114084), address: "" });
            } else if (type === "waydrop") {
              setWaydrop(waydropIndex, { isOpen: false, coords: new window.google.maps.LatLng(0, 0), address: "" });
            }
          }
          
          
        }}
        onInputChange={(event, newInputValue) => {
          setInputValue(newInputValue);
          // handleCheckCurrentLocation(newInputValue);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            // label={type == "pickup" ? "Pickup Location" : "Drop off Location"}
            label={
              type === "pickup"
                ? "Pickup Location"
                : type === "drop"
                ? "Drop off Location"
                : `Stop ${waydropIndex + 1}` // for waydrop
            }
            
            variant="outlined"
            size={"small"}
            fullWidth
          />
        )}
        renderOption={(option) => {
          const matches =
            option.structured_formatting.main_text_matched_substrings;
          const parts = parse(
            option.structured_formatting.main_text,
            matches && matches.length !== 0
              ? matches.map((match) => [
                  match.offset,
                  match.offset + match.length,
                ])
              : ""
          );

          return (
            <Grid container alignItems="center">
              <Grid item>
                <LocationOnIcon className={classes.icon} />
              </Grid>
              <Grid item xs>
                {parts.map((part, index) => (
                  <span
                    key={index}
                    style={{ fontWeight: part.highlight ? 700 : 400 }}
                  >
                    {part.text}
                  </span>
                ))}

                <Typography variant="body2" color="textSecondary">
                  {option.structured_formatting.secondary_text}
                </Typography>
              </Grid>
            </Grid>
          );
        }}
      />
    </>
  );
}




export default memo(MaterialAuto);
